import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import QueueItem from "../components/QueueItem";
import TagSearch from "../components/TagSearch";
import request from "request";
import { apiUrl } from "../util";
import { pollWithRetryPromise } from "../util/pollingPromiseUtil.js";
import { isBrowserCapture } from "../util/splitQueue";

class StartedQueue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      filterdItems: [],
      country: [],
      browserOnly: false,
      loading: true,
    };
  }
  cleanupGetDataPolling = null;
  pollingPromise = null;
  interval = () => {};
  intervalTime = new Date().getTime() + 180000;
  visibleEvent = () => {
    if (!document.hidden) {
      clearInterval(this.interval);
      if (this.intervalTime < new Date().getTime()) {
        this.getData();
      }
      this.interval = setInterval(() => {
        this.getData();
      }, 180000);
    } else {
      this.intervalTime = new Date().getTime() + 180000;
      clearInterval(this.interval);
    }
  };

  componentDidMount() {
    this.getData();
    this.interval = setInterval(() => {
      this.getData();
    }, 180000);
    document.addEventListener("visibilitychange", this.visibleEvent);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
    document.removeEventListener("visibilitychange", this.visibleEvent);
    if (this.cleanupGetDataPolling) {
      this.cleanupGetDataPolling();
    }
  }
  getData = () => {
    const { pollingPromise, cleanup } = pollWithRetryPromise();
    this.pollingPromise = pollingPromise;
    this.cleanupGetDataPolling = cleanup;
    // react-router leaves %2F encoded in params (amazon.com%2Fgp%2Fvideo).
    const company = decodeURIComponent(this.props.match.params.company);
    let url = `${apiUrl}/v1/admin/v2/getQueueItemsByCompany?company=${company}`;

    // request(
    //   {
    //     url: `${apiUrl}/v1/admin/v2/getQueueItemsByCompany?company=${company}`,
    //     headers: {
    //       Authorization: this.props.user.token,
    //     },
    //   },
    //   (err, res, data) => {
    //     if (err) {
    //       return;
    //     }
    //     const json = JSON.parse(data);
    //     /*
    //     json.companies.sort((a, b) => {
    //       if (a.name && b.name) {
    //         return a.name.toLowerCase() >= b.name.toLowerCase() ? 1 : -1;
    //       }
    //     });
    //     */
    //     this.setState({
    //       items: json.items,
    //       filterdItems: json.items.filter(item => {
    //         if (!this.state.country || this.state.country.length === 0) {
    //           return true;
    //         } else {
    //           return this.state.country.some(country =>
    //             item.url.endsWith(`#${country}`)
    //           );
    //         }
    //       }),
    //       loading: false,
    //     });
    //   }
    // );
    this.pollingPromise({
      url: `${apiUrl}/v1/admin/trigger_polling_data`,
      form: {
        type: "getQueueItemsByCompany",
        clearCache: true,
        data: JSON.stringify({
          company,
        }),
      },
      retryUrl: `${apiUrl}/v1/admin/get_polling_data`,
      retryForm: {
        type: "getQueueItemsByCompany",
        data: JSON.stringify({
          company,
        }),
      },
      token: this.props.user.token,
    })
      .then(json => {
        // const json = data.data;
        console.log("Fetched data:", json);
        this.setState({
          items: json.items,
          filterdItems: json.items.filter(item => {
            if (!this.state.country || this.state.country.length === 0) {
              return true;
            } else {
              return this.state.country.some(country =>
                item.url.endsWith(`#${country}`)
              );
            }
          }),
          loading: false,
        });

        if (this.cleanupGetDataPolling) {
          this.cleanupGetDataPolling();
          this.cleanupGetDataPolling = null;
        }
      })
      .catch(err => {
        console.error("Error fetching data:", err);
        this.setState({
          loading: false,
        });
      });
  };
  moveToQA = id => {
    request.post(
      {
        url: `${apiUrl}/queue/edit_type`,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.props.user.token,
        },
        form: { id, type: "problem" },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        this.getData();
      }
    );
  };
  remove = (id, url) => {
    this.setState({
      items: [],
      loading: true,
    });
    request.post(
      {
        url: `${apiUrl}/v1/admin/v2/queue/delete`,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.props.user.token,
        },
        form: { id, url },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        this.getData();
      }
    );
  };
  showAll = e => {
    e.preventDefault();
    const { company, important } = this.state;

    let qs = "?all=true";

    if (company) {
      qs = `${qs}&company=${company}`;
    }
    if (important) {
      qs = `${qs}&important=true`;
    }
    request(
      {
        url: `${apiUrl}/queue/${this.props.queue}${qs}`,
        headers: {
          Authorization: this.props.user.token,
        },
      },
      (err, res, data) => {
        if (err) {
          return;
        }
        const json = JSON.parse(data);
        this.setState({
          items: json.items,
          all: true,
        });
      }
    );
  };
  refilterData = items => {
    const { important, tlds, sects, country, platform } = this.state;

    let retData = items;

    if (important === "landing") {
      retData = items.filter(i => i.landingPage);
    }
    if (country) {
      if (country === "us") {
        retData = items.filter(i => {
          if (!i.url.endsWith("#uk") && !i.url.endsWith("#au")) {
            return true;
          }
          return false;
        });
      } else {
        retData = items.filter(i => {
          if (i.url.endsWith(`#${country}`)) {
            return true;
          }
          return false;
        });
      }
    }
    if (platform !== "all") {
      retData = retData.filter(q => q.platform === platform);
    }
    if (tlds && tlds.length > 0) {
      retData = retData.filter(q => {
        let tld = q.url.split("/")[2].split(".").slice(-2).join(".");

        if (tld === "co.uk" || tld === "com.au") {
          tld = q.url.split("/")[2].split(".").slice(-3).join(".");
        }
        return tlds.includes(tld);
      });
    }
    if (sects && sects.length > 0) {
      retData = retData.filter(q => {
        let found = false;
        let tld = q.url.split("/")[2].split(".").slice(-2).join(".");

        if (tld === "co.uk" || tld === "com.au") {
          tld = q.url.split("/")[2].split(".").slice(-3).join(".");
        }
        const company = this.state.comps.find(c => c.tld === tld);
        if (company && company.sectors) {
          sects.forEach(s => {
            if (!found && company.sectors.includes(s)) {
              found = true;
            }
          });
        }

        return found;
      });
    }
    return retData.slice(0, 500);
  };
  filterByCompany = (
    company,
    important,
    country,
    tldsi,
    platform,
    sectorsi
  ) => {
    let items = this.state.allItems;
    let landingPagesOnly = this.state.landingPagesOnly;
    let tlds = tldsi ? tldsi : this.state.tlds;
    let plat = platform ? platform : this.state.platform;
    let cntry = country ? country : this.state.country;
    let sects = sectorsi ? sectorsi : this.state.sects;

    if (company && this.state.company !== company) {
      this.setState(
        {
          company,
        },
        this.getData
      );
      return;
    }
    if (important) {
      if (important === "landing") {
        items = items.filter(i => i.landingPage);
        landingPagesOnly = true;
      } else if (important !== this.state.important) {
        this.setState(
          {
            important: important === "true" ? true : false,
            landingPagesOnly: false,
          },
          this.getData
        );
        return;
      }
    }
    if (cntry) {
      if (cntry === "us") {
        items = items.filter(i => {
          if (!i.url.endsWith("#uk") && !i.url.endsWith("#au")) {
            return true;
          }
          return false;
        });
      } else {
        items = items.filter(i => {
          if (i.url.endsWith(`#${cntry}`)) {
            return true;
          }
          return false;
        });
      }
    }
    if (tlds && tlds.length > 0) {
      items = items.filter(q => {
        let tld = q.url.split("/")[2].split(".").slice(-2).join(".");

        if (tld === "co.uk" || tld === "com.au") {
          tld = q.url.split("/")[2].split(".").slice(-3).join(".");
        }
        return tlds.includes(tld);
      });
    }
    if (sects && sects.length > 0) {
      items = items.filter(q => {
        let found = false;
        let tld = q.url.split("/")[2].split(".").slice(-2).join(".");

        if (tld === "co.uk" || tld === "com.au") {
          tld = q.url.split("/")[2].split(".").slice(-3).join(".");
        }
        const company = this.state.comps.find(c => c.tld === tld);
        if (company && company.sectors) {
          sects.forEach(s => {
            if (!found && company.sectors.includes(s)) {
              found = true;
            }
          });
        }

        return found;
      });
    }
    if (plat && plat !== "all") {
      items = items.filter(q => q.platform === plat);
    }
    this.setState({
      items: items.slice(0, 400),
      landingPagesOnly,
      tlds: tlds ? tlds : this.state.tlds,
      sects: sects ? sects : this.state.sects,
      platform: platform ? platform : this.state.platform,
      country: country ? country : this.state.country,
    });
  };
  doTldFilter = tlds => {
    this.filterByCompany(
      this.state.company,
      this.state.important,
      this.state.country,
      tlds,
      this.state.platform,
      this.state.sects
    );
  };
  doSectorFilter = sectors => {
    this.filterByCompany(
      this.state.company,
      this.state.important,
      this.state.country,
      this.state.tlds,
      this.state.platform,
      sectors
    );
  };
  handleSort = sort => {
    this.setState({
      sort,
    });
  };
  doCountryFilter = vals => {
    const { items } = this.state;
    const filterdItems = items.filter(item => {
      if (!vals || vals.length === 0) {
        return true;
      } else {
        return vals.some(country => {
          if (country === "us")
            return !item.url.endsWith(`#au`) && !item.url.endsWith(`#uk`);
          return item.url.endsWith(`#${country}`);
        });
      }
    });
    this.setState({ country: vals, filterdItems });
  };
  toggleBrowserOnly = e => {
    this.setState({ browserOnly: e.currentTarget.checked });
  };
  getSort = () => {
    const { sort } = this.state;

    if (sort === "time_new") {
      return (a, b) => (a.ctime >= b.ctime ? -1 : 1);
    }
    if (sort === "url") {
      return (a, b) => (a.url >= b.url ? 1 : -1);
    }
    return (a, b) => (a.ctime >= b.ctime ? 1 : -1);
  };
  render() {
    const { user } = this.props;
    const { items, all, sort, loading, filterdItems, browserOnly } =
      this.state;
    if (sort) {
      items.sort(this.getSort());
    }
    if (!user) {
      return (
        <Redirect
          to={{ pathname: "/", state: { from: this.props.location } }}
        />
      );
    }

    if (loading) {
      return <h1>Loading...</h1>;
    }

    const browserItems = (filterdItems || []).filter(isBrowserCapture);
    const shownItems = browserOnly ? browserItems : filterdItems;

    return (
      <div>
        <h1>Screening Queue</h1>
        <div className="w-100 flex items-center">
          <div className="w-25">
            <TagSearch
              options={["us", "au", "uk", "fr", "de"].map(val => {
                return {
                  label: val.toUpperCase(),
                  value: val,
                };
              })}
              callback={this.doCountryFilter}
              placeholder="Filter by Country"
              defaultTags={this.state.country}
            />
          </div>
          <div className="ph2 pt1">
            <label className="mb0 pointer">
              <input
                type="checkbox"
                checked={browserOnly}
                onChange={this.toggleBrowserOnly}
              />{" "}
              Browser captures only ({browserItems.length})
            </label>
          </div>
        </div>
        {shownItems &&
          shownItems.map(item => {
            let type;

            if (item.type === "qa") {
              type = "qa";
            } else if (item.type === "started_test") {
              type = "started";
            } else if (item.type === "ended_test") {
              type = "ended";
            }

            return (
              <QueueItem
                item={item}
                qType="new_queue"
                remove={this.remove}
                moveToQA={this.moveToQA}
                key={item.id}
                user={this.props.user}
                callback={this.getData}
              />
            );
          })}
      </div>
    );
  }
}

export default StartedQueue;
